import { Axios } from "@/utils/axios";
import { queryKeys } from "goi_common";
import { useQuery } from "react-query";

export type ConsultDeferKind = "holiday" | "weekend" | "night";

export type ServerTimeResponse = {
  timestamp: Date;
  is_night: boolean;
  is_weekend_consult_defer?: boolean;
  consult_defer_kind?: ConsultDeferKind | null;
};

/**
 * 여유 상담시간 선택을 열 구간.
 * 서버가 holiday > weekend > night 우선순위로 판정해 kind 하나로 내려주므로
 * is_night / is_weekend_consult_defer 를 따로 볼 필요 없다.
 */
export const isConsultTimeWindow = (serverTime?: ServerTimeResponse) =>
  Boolean(serverTime?.consult_defer_kind);

export const useGetServerTime = () => {
  return useQuery<ServerTimeResponse>(queryKeys.nightTime(), async () => {
    const response = await Axios.get("/now_time/");
    return response.data;
  });
};
